module.exports = __webpack_public_path__ + "icon_taloustiedot.079f198c5b49e6142751.svg";